import * as React from 'react'
import { useOV25UI } from '../../contexts/ov25-ui-context.js'

interface NoResultsProps {
  message?: string;
}

export const NoResults = ({ message }: NoResultsProps) => {
  const { allOptions, activeOptionId, getString } = useOV25UI();
  
  // Calculate message based on current option if not provided
  const displayMessage = message || (() => {
    const currentOption = allOptions.find(opt => opt.id === activeOptionId);
    return currentOption?.name.toLowerCase() === 'modules' 
      ? getString('noResultsModules', undefined, 'Select an object to replace or attach to.')
      : getString('noResultsDefault', undefined, 'No results found');
  })();

  return (
    <div id="ov25-no-results" className="ov:w-full ov:h-full ov:p-4 ov:pt-16 ov:flex ov:justify-center">
      <h3 className="ov:text-sm ov:text-(--ov25-secondary-text-color)/60">{displayMessage}</h3>
    </div>
  );
};

export default NoResults; 